module.exports = __webpack_public_path__ + "img/桃花.f25f6a86.gif";